import { useContext } from 'react';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import { Avatar, Card, CircularProgress, Grid, Hidden, Typography } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

export const WipDashboardTechnician = ({ classes }) => {
    const { state, array, handleTechCalender, handleChangeByTime, randomColor, handleTechOnClick } = useContext(EWIPDashboardScreenContext);
    return (
        <>
            {' '}
            {state.showTechnicianLoader ? (
                <div className="wip-dash-Card">
                    <WipScreenLoader />
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <Hidden only={['xs']}>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Typography vraient="h5" color="secondary" className="dashHeading">
                                    {'Jobs By Technicians'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ float: 'right', marginRight: 40, display: 'flex' }}>
                                    <div
                                        style={{
                                            padding: '2px 12px 0px 0px',
                                            fontSize: 20,
                                            fontWeight: 600,
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <span
                                            onClick={() =>
                                                handleTechCalender({
                                                    tid: '',
                                                    bn: array.selectedValueByTech,
                                                    name: '',
                                                    bid: ''
                                                })
                                            }
                                        >
                                            <DateRangeIcon />
                                        </span>
                                    </div>

                                    <div>
                                        {/* <select onChange={handleTechSelect} className="selectclass" value={array.selectedValueByTech}> */}
                                        {/* <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}> */}
                                        <select onChange={handleChangeByTime} className="selectclass" value={array.selectedValueByTech}>
                                            {state.chartdata.map((btn, i) => {
                                                return (
                                                    <option key={i} value={btn.name}>
                                                        {btn.name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>
                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                        <Grid container justifyContent="space-between">
                            <Grid item xs={12} sm={8} md={8} lg={10}>
                                <Typography variant="h7" color="secondary" style={{ fontWeight: 600 }}>
                                    <Typography vraient="h5" color="secondary" className="dashHeading">
                                        Jobs By Technicians &nbsp; &nbsp;Total : {array.techJobsTotal}
                                    </Typography>
                                </Typography>
                            </Grid>
                            <Grid item xs>
                                <div
                                    style={{
                                        margin: '0px 20px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">Branch</span>
                                    <select onChange={handleChangeByTime} className="selectclass" value={array.selectedValueByTech}>
                                        {state.chartdata.map((btn, i) => {
                                            return (
                                                <option key={i} value={btn.name}>
                                                    {btn.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>

                    <div style={{ padding: '0px 30px' }}>
                        <hr className="labeled-bordered-box" />
                    </div>
                    <Grid container spacing={2} style={{ minHeight: '110px', overflow: 'auto' }} className="wip-dash-Card-content">
                        {array.selectedFilterTechData.length == 0 ? (
                            <WipNoRecord />
                        ) : (
                            array.selectedFilterTechData.map((p) => {
                                return (
                                    <Grid
                                        item
                                        xs={6}
                                        sm={4}
                                        md={4}
                                        lg={3}
                                        xl={2}
                                        onClick={() => handleTechOnClick(p)}
                                        style={{ cursor: 'pointer' }}
                                        key={p.name}
                                    >
                                        <Grid container spacing={2} alignItems="center" className="wip-dash-Card-content-values">
                                            <Grid item>
                                                <Avatar
                                                    style={{
                                                        backgroundColor: randomColor()
                                                    }}
                                                >
                                                    {p.name[0]}
                                                </Avatar>
                                            </Grid>
                                            <Grid item>
                                                <div
                                                    style={{
                                                        paddingBottom: 10,
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    <span className="lableFont"> {p.name}</span>
                                                    <div className="valueFont">{p.total}</div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                );
                            })
                        )}
                    </Grid>
                </Card>
            )}
        </>
    );
};
